import * as React from 'react';
import { useEffect } from 'react';
import { Provider, useDispatch } from 'react-redux';
import store, { setFeatures, setLoaded, toggleFeature } from './user-settings/store';
import Panel from './user-settings/Panel';
import ThemingForm from './user-settings/ThemingForm';

const UserSettingsComponent = (props) => {
  const dispatch = useDispatch();
  const toggle = (key, value) => dispatch(toggleFeature({key, value}));

  useEffect(() => {
    dispatch(setFeatures(props.features));
    dispatch(setLoaded(true));
  }, []);

  return (
    <div className='user-settings'>
      <Panel
        label={I18n.t('profiles.settings.features.theme.label')}
        feature='theme'
        status='beta'
        statusLabel={I18n.t('profiles.settings.features.status.beta')}
        callback={(enabled) => toggle('theme', enabled ? 'auto' : enabled)}>
        <ThemingForm feature='theme' callback={(value) => toggle('theme', value)}/>
      </Panel>
    </div>
  );
}

const UserSettings = (props) => {
  return (
    <Provider store={store}>
      <UserSettingsComponent features={props.features}/>
    </Provider>
  );
};

export default UserSettings;
